import { useState } from "react";
import { monthlyData } from "@/mocks/ranking";

export default function MonthlyRanking() {
  const [active, setActive] = useState(0);
  const data = monthlyData[active];

  return (
    <section
      id="monthly"
      className="scroll-mt-16 border-y border-background-200 bg-background-100/70 py-12 md:py-16"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-bold tracking-widest text-accent-800">
              <i className="ri-calendar-event-fill"></i>
              月度精选
            </span>
            <h2 className="mt-4 font-serif text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              月度最劲爆瓜榜
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              每个月月初复盘上一个月话题，保留当月讨论声量最高、反转最精彩的几颗瓜。
            </p>
          </div>

          <div className="flex flex-wrap gap-2">
            {monthlyData.map((m, i) => (
              <button
                key={m.title}
                type="button"
                onClick={() => setActive(i)}
                className={`rounded-full px-4 py-2 text-sm font-semibold whitespace-nowrap transition-colors ${
                  active === i
                    ? "bg-accent-500 text-background-50"
                    : "border border-background-300 bg-background-50 text-foreground-700 hover:border-accent-300"
                }`}
              >
                {m.title}
              </button>
            ))}
          </div>
        </div>

        <ol className="mt-8 grid gap-4 lg:grid-cols-2">
          {data.items.map((item) => (
            <li key={item.rank} className="rise-in">
              <a
                href="#deep"
                className="flex h-full gap-4 rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-200 md:gap-5"
              >
                <div className="flex flex-col items-center">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-background-200 font-serif text-lg font-black text-foreground-800">
                    {item.rank}
                  </span>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="text-base font-bold leading-snug text-foreground-950">
                      {item.title}
                    </h3>
                    <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-800">
                      {item.tag}
                    </span>
                  </div>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <div className="mt-3 flex items-center gap-4 text-xs font-medium text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-fill text-primary-500"></i>
                      热度 {item.heat}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-refresh-fill text-accent-500"></i>
                      反转 {item.reversal}
                    </span>
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}